// extracted by mini-css-extract-plugin
export default {"cLink":"CustomLink_cLink__x0Aig"};